import { render, staticRenderFns } from "./ProWorksheetPhysicalExam.vue?vue&type=template&id=4f756dc6&scoped=true&"
import script from "./ProWorksheetPhysicalExam.vue?vue&type=script&lang=js&"
export * from "./ProWorksheetPhysicalExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f756dc6",
  null
  
)

export default component.exports